export const corporateLogin = {
  title: 'Login Corporativo',
  subtitle: 'Faça o login através do portal de um parceiro',
  emailAddress: 'E-mail',
  enter: 'Entrar',
  return: 'Retornar',
  loading: 'Carregando',
  error: {
    error: 'Erro',
    pickACompany: 'É necessário escolher uma empresa',
    noProviderFound: 'Não foi encontrado um provedor de login para o e-mail informado.',
    loadingFailed:
      'Não foi possível carregar a lista de provedores. Por favor, tente novamente.',
  },
  email: {
    required: 'O endereço de E-mail é obrigatório',
    invalid: 'O endereço de E-mail informado não é válido',
  },
};
